import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";

export default function AddTheme({ closeModal, alert, users, getThemes }) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          name: "",
          due_date: "",
          email: "",
          theme: "",
        }}
        onSubmit={(values) => {
          values.email = values.name;
          const user = users.find((u) => u.email === values.name);
          values.name = user.first_name + " " + user.last_name;

          const date = new Date(values.due_date);
          date.setDate(date.getDate() + 1);
          values.due_date = date;
          ApiService.post("trainings/create-theme-of-the-week", values).then(
            (res) => {
              console.log(res);
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
              }
              closeModal();
              getThemes();
            }
          );
        }}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
        }) => (
          <Form>
            <div className="form-group">
              <label>
                Presenter <span className="text-danger"> * </span>
              </label>

              <select
                type="text"
                className="form-control"
                name="name"
                onChange={handleChange}
                value={values.name}
                required
              >
                <option value="">--Select User--</option>

                {users.map((user, i) => (
                  <option value={user.email} key={i}>
                    {user.first_name + " " + user.last_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                Presenter Email <span className="text-danger"> * </span>
              </label>
              <select
                type="text"
                className="form-control"
                name="email"
                // required
                // onChange={handleChange}
                // value={values.email}
                disabled
                value={values.name}
              >
                <option value={values.name}>{values.name}</option>
                {/* {users.map((user, i) => (
                  <option value={user.email} key={i}>
                    {user.email}
                  </option>
                ))} */}
              </select>
            </div>
            <div className="form-group">
              <label>
                Due Date <span className="text-danger"> * </span>
              </label>
              <div className="form-group">
                <DatePicker
                  selected={values.due_date}
                  dateFormat="MMMM d, yyyy"
                  className="form-control"
                  name="due_date"
                  autoComplete="off"
                  minDate={new Date()}
                  onChange={(date) => setFieldValue("due_date", date)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                Theme <span className="text-danger"> * </span>
              </label>
              <Field
                as="textarea"
                type="text"
                col="4"
                id="tpoic"
                className="form-control item"
                name="theme"
                placeholder="Enter Theme"
                required
              />
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/addTheme.js